/**
 * AI 组件 Widget 类（6.2 BaseWidget 体系）
 * AIChat / AICopilot / AIGenerate
 *
 * 三者均有生成中交互语义：声明 6.3 瞬态（meta）行为钩子
 * isGenerating / messages / result（运行时状态，不持久化但可绑定）。
 */
import type { PropertyPaneConfig } from "@shared/types";

import { getMaterial } from "../materials";
import { BaseWidget } from "./base-widget";
import { buildMaterialPropertyPaneConfig } from "./property-pane";

function paneConfigFor(type: string, extraSections: PropertyPaneConfig[] = []): PropertyPaneConfig[] {
  return buildMaterialPropertyPaneConfig(getMaterial(type)?.propSchema ?? [], extraSections);
}

export class AIChatWidget extends BaseWidget {
  getWidgetType(): string {
    return "AIChat";
  }
  getPropertyPaneConfig(): PropertyPaneConfig[] {
    return paneConfigFor("AIChat");
  }
  getMetaProperties(): Record<string, unknown> {
    return { messages: [], isGenerating: false };
  }
}

export class AICopilotWidget extends BaseWidget {
  getWidgetType(): string {
    return "AICopilot";
  }
  getPropertyPaneConfig(): PropertyPaneConfig[] {
    return paneConfigFor("AICopilot");
  }
  getMetaProperties(): Record<string, unknown> {
    return { isGenerating: false };
  }
}

export class AIGenerateWidget extends BaseWidget {
  getWidgetType(): string {
    return "AIGenerate";
  }
  getPropertyPaneConfig(): PropertyPaneConfig[] {
    return paneConfigFor("AIGenerate");
  }
  getMetaProperties(): Record<string, unknown> {
    return { isGenerating: false, result: "" };
  }
}
